export default {
  white: '#FEFEFE',
  black: '#000000',
  gray_1: '#141414',
  green_1: '#018246',
  yellow_1: '#ffdf01',
};
